import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";
import { yang } from "@/images/";

const updateDialog = [
  new Dialog(
    "SONNY YANG: Dareth Schamren’s employee profile. Let’s see how he enjoys having to head in to the office during a global health crisis…",
    yang,
    require("@/audio/Pandemic-177-Sonny-MP3.mp3")
  ),
  new Dialog(
    "[Changed Dareth’s Job Position from ‘General Manager’ to ‘Essential Worker’]",
    require("@/images/Shibari_Computer_HR_Database.png")
  ),
  new Dialog(
    "[MEANWHILE.... AT DARETH SHAMREN'S HOUSE...]",
    require("@/images/Vincent_Dareths_House.png")
  ),
  new Dialog(
    "DARETH: Hang on brother, I’ve got another call coming through… Dareth Schamren speaking.",
    ""
  ),
  new Dialog(
    "SHIBARI HR REPRESENTATIVE: Hello Mr. Schamren, I’m calling from the Shibari International Headquarters in Geneva. Our employee records show that you have not clocked in to work in the last seven days.As you are listed as an ‘essential worker’ on our database, we strongly urge you to attend to your role at your local Shibari branch office as   soon as possible, otherwise we may be forced to terminate your employment",
    ""
  ),
  new Dialog(
    "DARETH: Impossible! I’m not one of those lowly essential workers - there must be some mistake! Looks like I’ll have to go and sort this out myself.",
    ""
  ),
  new Dialog("[DARETH SCHAMREN LEAVES THE HOUSE]", ""),
];

export class ComputerDatabase extends Scene {
  title = "COMPUTER DATABASE";
  get options(): any[] {
    return [
      new Choice("Udate Dareth Schamren's employee profile", async () => {
        await this.dialogRunner(updateDialog)
        this.state.storylines.darethDemoted = true;
        await this.navigate(scenes.HumanResources());
      }),
      new Choice("Update Karen Smith's employee profile ", async () => {
        await this.dialogRunner(
          [new Dialog("[The Computer EXPLODES in your face!]", "")])
        await this.navigate(scenes.EmergencyRoom())
      }),
      new Choice("Leave", async () => await this.navigate(scenes.HumanResources())),
    ];
  }
}

export default new ComputerDatabase();
